import React from "react";

export default function SustainableQuality() {
  return (
    <div className="steel-page">
      <div className="steel-container">
        <div className="steel-card">
          <div className="steel-body">
            {/* Heading */}
            <div className="steel-header">
              <h2>
                Sustainable Quality Steelmaking Conference-23rd – 24th April
                2026 in Jamshedpur, Jharkhand.
              </h2>
            </div>

            {/* ================= SESSION 1 ================= */}
            <div className="steel-content">
              <p>
                𝘾𝙤𝙡𝙡𝙖𝙗𝙤𝙧𝙖𝙩𝙞𝙫𝙚 𝗰𝙤-𝙤𝙥𝙚𝙧𝙖𝙩𝙞𝙤𝙣 𝙖𝙢𝙤𝙣𝙜 𝙋𝙧𝙞𝙢𝙖𝙧𝙮 𝙖𝙣𝙙 𝙎𝙚𝙘𝙤𝙣𝙙𝙖𝙧𝙮 𝙎𝙩𝙚𝙚𝙡
                𝙈𝙖𝙣𝙪𝙛𝙖𝙘𝙩𝙪𝙧𝙞𝙣𝙜 𝙎𝙚𝙘𝙩𝙤𝙧𝙨 𝙬𝙞𝙡𝙡 𝙗𝙚 𝙖 𝙜𝙖𝙢𝙚-𝙘𝙝𝙖𝙣𝙜𝙚𝙧 𝙞𝙣 𝙩𝙝𝙚 𝙟𝙤𝙪𝙧𝙣𝙚𝙮 𝙤𝙛
                𝙎𝙪𝙨𝙩𝙖𝙞𝙣𝙖𝙗𝙡𝙚 𝙌𝙪𝙖𝙡𝙞𝙩𝙮 𝙎𝙩𝙚𝙚𝙡𝙢𝙖𝙠𝙞𝙣𝙜 𝙞𝙣 𝙄𝙣𝙙𝙞𝙖"- Shri Yogesh Mandhani
                President, AIIFA Sustainable Steel Manufacturers Association. As
                a guest of honor in the inauguration session of the
                𝗜𝗻𝘁𝗲𝗿𝗻𝗮𝘁𝗶𝗼𝗻𝗮𝗹 𝗖𝗼𝗻𝗳𝗲𝗿𝗲𝗻𝗰𝗲 𝗼𝗻 𝗦𝘂𝘀𝘁𝗮𝗶𝗻𝗮𝗯𝗹𝗲 𝗤𝘂𝗮𝗹𝗶𝘁𝘆 𝗦𝘁𝗲𝗲𝗹𝗺𝗮𝗸𝗶𝗻𝗴 at
                Jamshedpur, Jharkhand today Shri Yogesh Mandhani reaffirmed
                AIIFA's commitment for partnership with Government-Industry-
                Academia for achieving sustainability and quality steel making
                in India.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
